import PhotoDefault from '@shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

const ChannelViewWindow = styled.img`
    border-radius: ${20 * Screen.widthRatio}px;
    bottom: ${160 * Screen.widthRatio}px;
    height: ${224 * Screen.widthRatio}px;
    width: ${400 * Screen.widthRatio}px;
    position: relative;
}
`;

export default withImage(ChannelViewWindow, true, PhotoDefault);
